import React from "react";
import {
    Button,
    DrawerBody,
    DrawerHeader,
    DrawerHeaderTitle,
    OverlayDrawer,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

// styles
import './PaymentImputations.View.Styles.css';

// component functions
import { IProps } from './PaymentImputations.View.Function';

// components
import PaymentImputationsComponent from '../PaymentImputations/PaymentImputations.Component';

const PaymentImputationsViewComponent = (props: IProps) => {
    const [t] = useTranslation();

    if (!props.paymentId) return null;

    return (
        <OverlayDrawer
            open={props.isOpen}
            onOpenChange={(_, data) => { if (!data.open) props.onClose(); }}
            position="end"
            size="medium"
        >
            <DrawerHeader>
                <DrawerHeaderTitle
                    action={
                        <Button
                            appearance="subtle"
                            aria-label={t('common.close', 'Cerrar')}
                            icon={<Dismiss24Regular />}
                            onClick={props.onClose}
                        />
                    }
                >
                    {props.title ?? t('cashflow.imputations.viewTitle', 'Imputaciones del Pago')}
                </DrawerHeaderTitle>
            </DrawerHeader>
            <DrawerBody>
                <div className="paymentImputationsViewDrawerBody">
                    <PaymentImputationsComponent
                        paymentId={props.paymentId}
                        showTitle={false}
                    />
                </div>
            </DrawerBody>
        </OverlayDrawer>
    );
};

export default PaymentImputationsViewComponent;
